import { z } from 'zod';

import commonLocales from 'common/zod/locales';
import { fileUploadSchema } from 'common/zod/schemas';

import locales from './locales';

export const transferInformationFormSchema = z.object({
  amount: z
    .number({
      invalid_type_error: commonLocales.errors.required,
      required_error: commonLocales.errors.required,
    })
    .positive({ message: locales.errors.insufficientAmount }),
  label: z.string().trim(),
  supportingDocument: fileUploadSchema,
});

export type TransferInformationFormSchema = z.infer<
  typeof transferInformationFormSchema
>;
